export default __webpack_public_path__ + "static/media/icon_crmc.e7bb40b1.svg";